export const toRealZavrsniRadStatus = (customStatus) => {
  switch(customStatus){
    case "Slobodan": {
      return "Odobren";
    }
    case "Zauzet": {
      return "Dodjeljen";
    }
    case "Odbranjen": {
      return "Odbranjen";
    }
    default: {
      return null;
    }
  }
}